// extracted by mini-css-extract-plugin
export var acitonButtons = "_h4-0";
export var additionalIcon = "_h4-f";
export var block = "_h4-1";
export var blockContent = "_h4-7";
export var blockDescription = "_h4-8";
export var blockIcon = "_h4-9";
export var blockTitle = "_h4-6";
export var border = "_h4-a";
export var center = "_h4-l";
export var edge = "_h4-b";
export var edgeLabel = "_h4-c";
export var edgePath = "_h4-d";
export var error = "_h4-e";
export var flowchart = "_h4-g";
export var flowchartContent = "_h4-h";
export var highlighted = "_h4-3";
export var hover = "_h4-4";
export var icon = "_h4-i";
export var left = "_h4-m";
export var navButton = "_h4-j";
export var navButtons = "_h4-k";
export var right = "_h4-n";
export var selected = "_h4-2";
export var small = "_h4-5";